import { TEnumerationType } from './type.d';
export type TGenreKey = 'mainGenre' | 'subGenre' | 'mainSubGenre' | 'ieggGenre' | 'dataaiGenre';
export type TGenreValue = 'main' | 'sub' | 'mainsub' | 'iegg' | 'appannie';

export interface IGenreProp {
  // 自身的key
  key: TGenreKey;
  // 显示的文本
  label: string;
  // 转换中英文使用到的key
  labelKey?: string;
  // 传递至后端的值
  value: TGenreValue;
  enumType: TEnumerationType;
};

export type IGenre = Record<TGenreKey, IGenreProp>

export const GENRE: IGenre = {
  mainGenre: {
    label: 'Main Genre',
    labelKey: 'dbi_main_genre',
    value: 'main',
    key: 'mainGenre',
    enumType: 'genre',
  },
  subGenre: {
    label: 'Sub Genre',
    labelKey: 'dbi_sub_genre',
    value: 'sub',
    key: 'subGenre',
    enumType: 'genre',
  },
  mainSubGenre: {
    label: 'Main + Sub Genre',
    labelKey: 'dbi_main_sub_genre',
    value: 'mainsub',
    key: 'mainSubGenre',
    enumType: 'genre',
  },
  ieggGenre: {
    label: 'IEGG Genre',
    labelKey: 'dbi_top_iegg_genre',
    value: 'iegg',
    key: 'ieggGenre',
    enumType: 'genre',
  },
  dataaiGenre: {
    label: 'data.ai Genre',
    labelKey: 'dbi_top_dataai_genre',
    value: 'appannie',
    key: 'dataaiGenre',
    enumType: 'genre',
  }
};
